import { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getMachineGroupsUseCase } from "@src/cloud-connect/namespace-configuration/use-cases/get-machine-groups-use-case";
import { errorSnackbar } from "@src/cloud-connect/snackbars/entities/snackbar-launcher";
import { useI18N } from "@src/language/language-context";
import { RootState } from "@src/reducers/store";
import { MachineGroup } from "@src/types/namespace-configuration";

export const useMachineGroupsListAdminPanelHook = () => {
  const i18n = useI18N();
  const authContext = useSelector(
    (state: RootState) => state.yourSlice.authContext,
  );
  const [machineGroups, setMachineGroups] = useState<MachineGroup[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  const texts = {
    noMachineGroups: i18n(
      "modules.machineGroupsListAdminPanel.noMachineGroups",
    ),
    failedToFetchMachineGroups: i18n(
      "modules.machineGroupsListAdminPanel.failedToFetchMachineGroups",
    ),
    expandGroup: i18n("modules.machineGroupsListAdminPanel.expandGroup"),
    collapseGroup: i18n("modules.machineGroupsListAdminPanel.collapseGroup"),
    editGroup: i18n("modules.machineGroupsListAdminPanel.editGroup"),
    sources: i18n("modules.machineGroupsListAdminPanel.sources"),
  };

  const refreshMachineGroups = useCallback(async () => {
    if (!authContext) return;

    setIsLoading(true);
    try {
      const result = await getMachineGroupsUseCase();
      if (result.success) {
        setMachineGroups(
          Array.isArray(result.data?.items) ? result.data.items : [],
        );
      } else {
        errorSnackbar(texts.failedToFetchMachineGroups);
      }
    } catch (error) {
      console.error(error);
      errorSnackbar(texts.failedToFetchMachineGroups);
    } finally {
      setIsLoading(false);
    }
  }, [authContext]);

  useEffect(() => {
    void refreshMachineGroups();
  }, [refreshMachineGroups]);

  return {
    machineGroups,
    permissions: authContext?.permissions ?? [],
    isLoading,
    refreshMachineGroups,
    texts,
  };
};
